import { render, staticRenderFns } from "./DescriptiveLoader.vue?vue&type=template&id=5028f4f7"
import script from "./DescriptiveLoader.vue?vue&type=script&lang=ts"
export * from "./DescriptiveLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports